module KendoWidgets
{
	export class ToggleButtonListOptions
	{
		css?: string;
		selectionMode?: ToggleSelectionModeEnum;
		items: ToggleButtonItem[];
	}

	export class ToggleButtonList extends kendo.ui.Widget implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.ToggleButtonList; }

		constructor(element: Element, options?: KendoWidgets.ToggleButtonListOptions)
		{
			if (options == null)
				options = new KendoWidgets.ToggleButtonListOptions();

			if (options.selectionMode == null) options.selectionMode = ToggleSelectionModeEnum.Single;

			//#region Items
			let toggleButtonItems: any[] = [];
			for (let item of options.items)
			{
				let toggleButtonItem: any = {};
				toggleButtonItem.text = item.text;
				toggleButtonItem.encoded = false;
				toggleButtonItem.icon = item.icon;
				toggleButtonItem.selected = item.selected;
				toggleButtonItem.imageUrl = item.imageUrl;
				toggleButtonItems.push(toggleButtonItem);
			}
			//#endregion

			super(element, options);

			$(element).kendoButtonGroup(
				{
					selection: options.selectionMode,
					items: toggleButtonItems
				});

			//#region Add click event
			for (let buttonItem of Array.from(element.children))
			{
				$(buttonItem).click((e) =>
				{
					let index = $(e.currentTarget).index();
					if (options!.items[index].click != null)
					{
						let clickEvent = new ToogleButtonListClickEvent();
						clickEvent.item = options!.items[index];
						clickEvent.selected = !$(e.currentTarget).hasClass("k-state-active");
						options!.items[index].click!(clickEvent);
					}
				});
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion
	}

	ToggleButtonList.fn = ToggleButtonList.prototype;
	ToggleButtonList.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	ToggleButtonList.fn.options.name = "ToggleButtonList";
	kendo.ui.plugin(ToggleButtonList);

	export enum ToggleSelectionModeEnum
	{
		Single = "single",
		Multiple = "multiple"
	}

	export class ToggleButtonItem
	{
		text: string;
		imageUrl?: string;
		icon?: string;
		selected?: boolean;
		click?: (e: ToogleButtonListClickEvent) => void;
	}

	class ToogleButtonListClickEvent
	{
		item: ToggleButtonItem;
		selected: boolean;
	}
}

interface JQuery
{
	kendoToggleButtonList(options?: KendoWidgets.ToggleButtonListOptions): JQuery;
	data(key: "kendoToggleButtonList"): KendoWidgets.ToggleButtonList;
}